export const tasks = [
  {
    id: "1",
    title: "Create homepage layout",
    userId: "123",
    state: "Active",
    isBug: false,
    iteration: 1,
    dueDate: "07/12/23",
    areaPath: "/Main",
    description: "Design and implement the layout for the homepage",
    comments: [],
    hoursRemaining: "23",
    hoursCompleted: "4",
  },
  {
    id: "2",
    title: "Implement product search functionality",
    userId: "123",
    state: "Active",
    isBug: false,
    iteration: 1,
    dueDate: "07/19/23",
    areaPath: "/Main",
    description:
      "Add search functionality to allow users to search for products",
    comments: [],
    hoursRemaining: "12",
    hoursCompleted: "2",
  },
  {
    id: "3",
    title: "Fix navigation menu alignment issue",
    userId: "345",
    state: "Code Review",
    isBug: true,
    iteration: 2,
    dueDate: "08/11/23",
    areaPath: "/Main",
    description:
      "Resolve alignment issue in the navigation menu on smaller screens",
    comments: [],
    hoursRemaining: "12",
    hoursCompleted: "4",
  },
  {
    id: "4",
    title: "Add user registration feature",
    userId: "123",
    state: "Testing",
    isBug: true,
    iteration: 3,
    dueDate: "07/12/23",
    areaPath: "/Authentication",
    description:
      "Implement user registration functionality to allow users to create accounts",
    comments: [],
    hoursRemaining: "6",
    hoursCompleted: "3",
  },
  {
    id: "5",
    title: "Optimize product images for faster loading",
    userId: "345",
    state: "Not Started",
    isBug: false,
    iteration: 2,
    dueDate: "07/23/23",
    areaPath: "/Performance",
    description:
      "Optimize product images by compressing and resizing them for improved page load times",
    comments: [],
    hoursRemaining: "6",
    hoursCompleted: "4",
  },
];
